const PRECISION_ROUNDING_FACTOR = 1000;
const PARALLAX_INTENSITY_FACTOR = 0.1;
// Calculate how much of the slider is visible
function calculateVisibilityRatio(element) {
    const elementRect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const topVisible = Math.max(0, elementRect.top);
    const bottomVisible = Math.min(viewportHeight, elementRect.bottom);
    const visibleHeight = bottomVisible - topVisible;
    return Math.max(0, Math.min(1, visibleHeight / elementRect.height));
}
// Adds a horizontal parallax effect on scroll to a Swiper slider
export function addParallaxOnScrollToSwiper(swiperInstance) {
    const slider = swiperInstance.el;
    if (!slider)
        return;
    const sliderList = slider.querySelector('.c-slider__list');
    if (!(sliderList instanceof HTMLElement))
        return;
    const state = {
        scrollTranslate: 0,
        isUserInteracting: false,
        animationFrameId: null,
        lastScrollY: window.scrollY,
    };
    const applyTransform = () => {
        const swiperTranslate = swiperInstance.translate || 0;
        sliderList.style.transform = `translate3d(${swiperTranslate + state.scrollTranslate}px, 0, 0)`;
        sliderList.style.transition = 'transform 0.1s ease-out';
        state.animationFrameId = null;
    };
    function handleScroll() {
        if (state.isUserInteracting)
            return;
        const visibilityRatio = calculateVisibilityRatio(slider);
        const currentScrollY = window.scrollY;
        const deltaY = currentScrollY - state.lastScrollY;
        const isScrollingUp = deltaY < 0;
        state.lastScrollY = currentScrollY;
        const currentTranslate = swiperInstance.translate || 0;
        const wrapperEl = swiperInstance.wrapperEl;
        const wrapperWidth = wrapperEl.offsetWidth;
        const totalContentWidth = wrapperEl.scrollWidth;
        const maxAllowedTranslate = wrapperWidth - totalContentWidth;
        const slidesOffsetBefore = swiperInstance.params.slidesOffsetBefore || 0;
        // Apply parallax only when slider is visible, with reduced intensity
        let nextScrollTranslate = state.scrollTranslate - deltaY * PARALLAX_INTENSITY_FACTOR * visibilityRatio;
        let nextTotal = currentTranslate + nextScrollTranslate;
        // Clamp at the end of the slider (left side)
        if (nextTotal <= maxAllowedTranslate && !isScrollingUp) {
            nextScrollTranslate = maxAllowedTranslate - currentTranslate;
        }
        // Clamp at the beginning of the slider (right side)
        if (nextTotal > slidesOffsetBefore) {
            nextScrollTranslate = slidesOffsetBefore - currentTranslate;
        }
        state.scrollTranslate = Math.round(nextScrollTranslate * PRECISION_ROUNDING_FACTOR) / PRECISION_ROUNDING_FACTOR;
        if (!state.animationFrameId) {
            state.animationFrameId = requestAnimationFrame(applyTransform);
        }
    }
    // Track user interaction
    swiperInstance.on('touchStart', () => {
        state.isUserInteracting = true;
    });
    swiperInstance.on('touchEnd', () => {
        state.isUserInteracting = false;
    });
    const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
            window.addEventListener('scroll', handleScroll, { passive: true });
            // Initialization
            handleScroll();
        }
        else {
            window.removeEventListener('scroll', handleScroll);
        }
    }, { threshold: 0 });
    observer.observe(slider);
    // Remove event listeners and animation frame when the Swiper instance is destroyed
    swiperInstance.on('destroy', () => {
        window.removeEventListener('scroll', handleScroll);
        if (state.animationFrameId)
            cancelAnimationFrame(state.animationFrameId);
        observer.disconnect();
    });
}
